import Svg, { Mask, Path, Rect } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const UndefinedMedium = (props: FlagsSvgProps) => {
  return (
    <Svg width={48} height={32} viewBox="0 0 48 32" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_3883" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z"
        fill="white"
      />
      <Path
        d="M4 0V1H44V0V-1H4V0ZM48 4H47V28H48H49V4H48ZM44 32V31H4V32V33H44V32ZM0 28H1V4H0H-1V28H0ZM4 32V31C2.34315 31 1 29.6569 1 28H0H-1C-1 30.7614 1.23858 33 4 33V32ZM48 28H47C47 29.6569 45.6569 31 44 31V32V33C46.7614 33 49 30.7614 49 28H48ZM44 0V1C45.6569 1 47 2.34315 47 4H48H49C49 1.23858 46.7614 -1 44 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_3883)"
      />
      <Rect x={4.09998} y={25} width={6} height={3} rx={0.8} fill="#E6E6E6" />
      <Rect x={4} y={19} width={23} height={3} rx={0.8} fill="#E6E6E6" />
      <Rect x={14.1} y={25} width={6} height={3} rx={0.8} fill="#E6E6E6" />
      <Rect x={24.1} y={25} width={7} height={3} rx={0.8} fill="#E6E6E6" />
      <Rect x={35} y={25} width={6} height={3} rx={0.8} fill="#E6E6E6" />
      <Rect x={4} y={9} width={10} height={7} rx={1.6} fill="#E6E6E6" />
    </Svg>
  )
}
